import type { ComponentProps } from 'react';

export const ConvertIcon = (props:ComponentProps<'svg'>) => (
  <svg width="29" height="83" viewBox="0 0 29 83" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1.73145 1.00146L25.7314 42.4829L1.73145 81.0015" stroke="url(#paint0_radial_727_1225)" strokeWidth="4" />
    <defs>
      <radialGradient id="paint0_radial_727_1225" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(13.7314 0.902378) rotate(90) scale(80.101 12)">
        <stop stopColor="#FFEA00" />
        <stop offset="1" stopColor="#FEBB35" />
      </radialGradient>
    </defs>
  </svg>


)